// @react
import React, { ReactElement } from 'react'
// @libraries
import DocumentTitle from 'react-document-title'
// @components
import TextLink from '@bit/atd.web.text-link'
import PageTitle from '@bit/atd.web.page-title'
// @module components
import NetworkTabs from 'modules/profile/components/NetworkTabs'
import PageWrapper from 'modules/profile/components/PageWrapper'
import Helper from '../../../../utils/Helper.class'

/**
 * 5.0.6 Profile - Network
 * UX: https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=3247%3A5776
 */

type PropsType = any

const Network = (props: PropsType): ReactElement => {
  return (
    <PageWrapper>
      <DocumentTitle title="Profile - Network | ATD">
        <>
          <PageTitle
            smallMargin
            subtitle={
              <>
                Manage your network. You can see your{' '}
                <TextLink
                  href={Helper.getPathFromRouteKey(
                    'MYATD_ACTIVITYHISTORY_NETWORKACTIVITY',
                  )}
                  variant="primary"
                >
                  Network Activity
                </TextLink>{' '}
                <span>in MyATD.</span>
              </>
            }
          >
            My Network
          </PageTitle>
          <NetworkTabs />
        </>
      </DocumentTitle>
    </PageWrapper>
  )
}

export default Network
